import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { CATALOG_FEATURE, CatalogState, StateWithCatalog } from '../catalog-state';

export const getFeatureState: MemoizedSelector<StateWithCatalog, CatalogState> =
  createFeatureSelector<CatalogState>(CATALOG_FEATURE);
